export default {
  'en-US': {
    shippingOptions: {
      Ground: 'Ground',
      Expedited: 'Expedited',
      Overnight: 'Overnight'
    }
  }
}
